module.exports = __webpack_public_path__ + "img/elo.3510af7c.png";